



















import { IGebruiker } from '@/model/IGebruiker';
import { authService } from '@/services/AuthService';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { email, required } from 'vuelidate/lib/validators';
import { Action, State } from 'vuex-class';

@Component({
  validations: {
    state: {
      email: {
        required,
        email
      }
    }
  }
})
export default class AppGebruikerGegevens extends Vue {
  @State(state => state.gebruiker)
  public gebruiker!: IGebruiker;
  @Action('gebruiker/getGebruiker')
  private getGebruiker!: (force?: boolean) => Promise<IGebruiker>;
  @Action('gebruiker/updateEmail')
  private updateEmail!: (email: string) => Promise<void>;

  public state: { email: string | undefined } = {
    email: undefined
  };

  created() {
    this.getGebruiker().then(g => {
      this.state.email = g.email;
    });
  }

  goBack() {
    this.$router.replace({ name: 'gebruiker-verificatie-email' });
  }

  save() {
    this.updateEmail(this.state.email ?? '').then(() => {
      // go back to uw gegevens
      // todo: we probably shouldn't go back but logout and let auth0 do it's verification dance
      // backend should get notified by auth0 when email is confirmed before the updated email is sent to Boss
      // after logout navigate to page with instructions
      //this.goBack();
      authService.logout();
    });
  }

  cancel() {
    this.goBack();
  }
}
